import React, { useEffect } from "react";
import { X } from "lucide-react";

const CONTENT = {
  personvern: {
    title: "Personvernerklæring",
    body: [
      "MobilHub behandler personopplysninger i tråd med personopplysningsloven og GDPR.",
      "Når du sender inn et skjema (bestilling eller salgsforespørsel), lagrer vi opplysningene du oppgir – som navn, telefonnummer, e-postadresse og informasjon om enheten – for å kunne svare på henvendelsen din og levere tjenesten.",
      "Opplysningene brukes kun til dette formålet, deles ikke med uvedkommende, og oppbevares ikke lenger enn nødvendig.",
      "Du har rett til innsyn, retting og sletting av dine opplysninger. Ta kontakt med oss for å utøve disse rettighetene.",
    ],
  },
  cookies: {
    title: "Informasjonskapsler (cookies)",
    body: [
      "Nettstedet bruker kun nødvendige informasjonskapsler for at siden skal fungere.",
      "Vi setter ikke markedsførings- eller sporingskapsler uten ditt samtykke.",
      "Du kan når som helst slette informasjonskapsler i nettleseren din.",
    ],
  },
  vilkar: {
    title: "Vilkår og betingelser",
    body: [
      "En bestilling via nettstedet er en forespørsel og er ikke bindende før MobilHub har bekreftet tidspunkt.",
      "Priser oppgitt i priskalkulatoren er veiledende. Endelig pris fastsettes etter diagnostikk av enheten.",
      "Ved salg og innbytte fastsettes endelig pris etter fysisk kontroll av enheten. Kunden er ansvarlig for å logge ut av iCloud/Google-konto og fjerne sperrer før innlevering.",
      "Ta vare på egne data. Vi anbefaler sikkerhetskopi før innlevering til reparasjon.",
    ],
  },
};

export default function LegalModal({ type, onClose }) {
  useEffect(() => {
    if (!type) return;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [type, onClose]);
  if (!type) return null;
  const data = CONTENT[type];
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="legal-modal">
      <div className="absolute inset-0 bg-navy/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-lg rounded-2xl bg-white shadow-xl max-h-[85vh] overflow-y-auto">
        <div className="sticky top-0 flex items-center justify-between border-b border-hairline bg-white px-6 py-4">
          <h3 className="font-heading text-xl font-bold text-navy">{data.title}</h3>
          <button onClick={onClose} className="flex h-9 w-9 items-center justify-center rounded-lg text-ink/60 hover:bg-slate-100" data-testid="legal-close"><X className="h-5 w-5" /></button>
        </div>
        <div className="space-y-3 px-6 py-5">
          {data.body.map((p, i) => <p key={i} className="text-sm leading-relaxed text-ink/75">{p}</p>)}
        </div>
      </div>
    </div>
  );
}

export { CONTENT };
